export const SIGN_IN_TRANSLATE = {
    signIn: {
        breadcrumbName: "Sign In",
        form: {
            title: "Sign In",
            fields: {
                login: {
                    label: "Username",
                    placeholder: "Enter your username"
                },
                password: {
                    label: "Password",
                    placeholder: "Enter your password"
                }
            },
            actions: {
                save: {
                    text: "Sign In"
                }
            }
        }
    },
}
